import axiosClient from 'utils/axios';
import { BASE_URL } from 'utils/baseUrlProvider';

const walletBaseUrl = `${BASE_URL}/accounting/wallet`;

export async function fetchPatientWalletStatement(patientId) {
  const response = await axiosClient.get(
    `${walletBaseUrl}/${encodeURIComponent(patientId)}/ledger-statement/`
  );
  return response.data;
}

export async function depositPatientAdvance(payload) {
  const response = await axiosClient.post(`${walletBaseUrl}/deposit/`, payload);
  return response.data;
}

export async function settlePatientWallet(payload) {
  const response = await axiosClient.post(`${walletBaseUrl}/settle/`, payload);
  return response.data;
}